exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".review-content {\n  margin-top: 50px; }\n  .review-content .wrap-reviews-input {\n    margin: 0 0 20px; }\n    .review-content .wrap-reviews-input input {\n      width: 100%;\n      border: none;\n      border-bottom: 1px solid #dedede;\n      font-size: 14px;\n      font-family: 'helveticaneuemedium'; }\n  .review-content button {\n    background: #572f76;\n    border: none;\n    color: #fff;\n    text-transform: uppercase;\n    font-size: 14px;\n    padding: 10px 20px;\n    cursor: pointer;\n    border-radius: 20px;\n    margin-top: 20px;\n    width: auto;\n    height: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/reviews/reviews.component.scss
// module id = ../../../../../src/app/components/reviews/reviews.component.scss
// module chunks = main